import { hexToRGBA } from 'utils/styledUtils';

import { NEUTRAL_0, NEUTRAL_900 } from 'styles/tokens';

/*
 * hexToRGBA emits CSS relative color syntax (rgb(from <color> r g b / alpha)) when passed a
 * CSS custom property reference. This requires Safari 16.4+, Chrome 119+, Firefox 128+ (all 2023+).
 * Our browserslist target (>0.2%, not dead, last 3 versions) excludes Safari < 16.4.
 */
export const OVERLAY_DARKEST = hexToRGBA(NEUTRAL_900, '0.72');
export const OVERLAY_DARK = hexToRGBA(NEUTRAL_900, '0.56');
export const OVERLAY_LIGHT = hexToRGBA(NEUTRAL_0, '0.8');

export { BLACK_ALPHA_005 as OVERLAY_REDUCED_MOTION } from 'styles/tokens';
